import React from "react";

export default function AdminWrapper({ children }) {
  return (
    <div className="page-wrapper">
      <div className="container-fluid min_height">{children}</div>
    </div>
  );
}
